import React, { useCallback, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faEnvelope,
  faLock,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import Api_Instance from "../../api/Api_Instance";
import { endpoints } from "../../api/endpoints";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { setForgetPassword,  setTokenAction } from "../../redux/slice/Slice";
import Loader from "../../common/loader/Loader";
import Forgetpassword from "../forgetpassword";
import Otp from "../forgetpassword/Otp";
import Confirmpassword from "../forgetpassword/Confirmpassword";
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

function Login({ onClose }) {
  const [isLogin, setIsLogin] = useState(true);
  const [close, setClose] = useState(true);
  const [ispassOpen, setIspassOpen] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [login, setLogin] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.auth.modal);
  const isModel = useSelector((state) => state?.auth?.forgetpass)
  const api = Api_Instance.unAuth();
  const notify = () => toast.success("Login successfully");
  const handleCircleClick = (index) => {
    setFocusedIndex(index);
  };
  const [loginpass, setLoginpass] = useState({
    email: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = {
      ...login,
      [name]: value,
    };
    setLogin(data);
  };

  const handleSubmit = useCallback(
    debounce(async () => {
      const validationErrors = validate(login);
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        setLoading(true);
        try {
          const response = await api("POST", endpoints.LOGIN_API, login);
          setLogin({
            email: "",
            password: "",
          });

          if (response.data.status) {
            notify();
            dispatch(setTokenAction(response?.data?.data?.access_token?.access));
            setClose(false);
            onClose();
          } else {
            throw new Error(response.data.message);
          }
        } catch (error) {
          toast.error(error.response?.data?.message || error.message);
        } finally {
          setLoading(false);
        }
      }
    }, 1500),
    [login, api, dispatch, notify, onClose]
  );

  const validate = (values) => {
    const error = {}
    const requiredFields = ["email", "password"];
    requiredFields.forEach((field) => {
      const value = values[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        error[field] = `${field.replace(/_/g, " ")} is required`;
      }
    });
    return error
  }
 
  const handleClose = () => {
    setIspassOpen(false)
  }
  const handleOpen = () => {
    dispatch(setForgetPassword({
      email: true,
      otp: false,
      confirmpassword: false
    }))
    // onClose()
  }

  const enterKye = (e) => {
    if (e.key === "Enter") {
      handleSubmit()
    }
  }
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 backdrop-blur-sm xl:px-5 lg:px-5 md:px-5 px-5">
      <div className="relative bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
        >
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </button>
        <div className="flex justify-center mb-4">
          <div
            className="text-center mx-4 cursor-pointer"
            onClick={() => setIsLogin(true)}
          >
            <h2
              className={`text-xl font-medium mb-2 ${isLogin ? "text-text_color" : ""
                }`}
            >
              Login
            </h2>
            {isLogin && (
              <hr className="border-b border-gray-400 w-28 mx-auto" />
            )}
          </div>
          {/* <div
            className="text-center mx-4 cursor-pointer"
            onClick={() => setIsLogin(false)}
          >
            <h2
              className={`text-xl font-medium mb-2 ${!isLogin ? "text-text_color" : ""
                }`}
            >
              Register
            </h2>
            {!isLogin && (
              <hr className="border-b border-gray-400 w-28 mx-auto" />
            )}
          </div> */}
        </div>

        {isLogin ? (
          <form className="max-w-md mx-auto">
            <div className="mb-4 relative">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="username"
              >
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="absolute left-3 top-10 text-gray-500"
                />
                Username
              </label>
              <input
                className="appearance-none border rounded w-full py-2 pl-10 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="username"
                type="text"
                name="email"
                value={login.email}
                placeholder="Username"
                onChange={(e) => handleChange(e)}
              />
              {errors.email && (
                <p className="text-star_color text-sm">{errors.email}</p>
              )}
            </div>
            <div className="mb-6 relative">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="password"
              >
                <FontAwesomeIcon
                  icon={faLock}
                  className="absolute left-3 top-10 text-gray-500"
                />
                Password
              </label>
              <input
                className="appearance-none border rounded w-full py-2 pl-10 pr-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                id="password"
                type={showPassword ? "text" : "password"}
                name="password"
                value={login.password}
                onChange={(e) => handleChange(e)}
                placeholder="************"
                onKeyPress={enterKye}
              />
              {errors.password && (
                <p className="text-star_color text-sm">{errors.password}</p>
              )}
              <button
                type="button"
                className="absolute right-2 top-9 text-gray-500 bg-white"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  size="sm"
                />
              </button>
              <span className="flex justify-end items-center text-sm">
                <a className="hover:font-semibold cursor-pointer" onClick={() => { handleOpen() }}>
                  Forgot Password?
                </a>
              </span>
            </div>
            <div className="flex items-center justify-between">
              <button
                className="bg-primaryColor text-white w-full font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex items-center justify-center [transition:all_.15s_ease-in-out]"
                type="button"
                onClick={handleSubmit}
                disabled={loading}

              >
                {loading ? (
                  <Loader />
                ) : (
                  "Sign In"
                )}
              </button>

            </div>
          </form>
        ) : (
          <>
          </>
          // <div className="text-center">
          //   <h2 className="text-xl font-medium mb-4">Select User Type</h2>
          //   <div className="flex flex-col md:flex-row md:justify-around gap-4">
          //     {circles.map((circle, index) => (
          //       <div
          //         key={index}
          //         className={`text-center relative ${index === focusedIndex ? "border-black" : ""
          //           }`}
          //       >
          //         <div
          //           className={`rounded-full border border-[#7e8c99] w-24 h-24 mx-auto mb-2 flex items-center justify-center cursor-pointer ${index === focusedIndex ? "border-black" : ""
          //             }`}
          //           onClick={() => handleCircleClick(index)}
          //         >
          //           <img
          //             src={circle.imageSrc}
          //             alt={circle.alt}
          //             className={`w-16 h-16 ${index === focusedIndex ? "filter-black" : ""
          //               }`}
          //           />
          //           {index === focusedIndex && (
          //             <div className="absolute md:top-0 md:right-0 right-32 hidden sm:block ">
          //               <FaCheckCircle className="text-black-300 text-3xl rounded-full bg-white p-1" />
          //             </div>
          //           )}
          //         </div>
          //         <p>{circle.label}</p>
          //       </div>
          //     ))}
          //   </div>
          //   <div className="flex justify-center mt-5">
          //     <div className="bg-primaryColor rounded-md w-32 [transition:all_.15s_ease-in-out]">
          //       <NavLink
          //         to={focusedIndex == 0 ? "/franchisor" :
          //           focusedIndex == 1
          //             ? "/Invester" : focusedIndex == 2 &&
          //             "/channelpartnerregistration"
          //         }
          //       >
          //         <button
          //           className="text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
          //           onClick={() => {
          //             onClose()
          //             // onClose(); focusedIndex == 0 
          //             //   && dispatch(setModal(true))
          //           }}
          //         >
          //           Next
          //         </button>
          //       </NavLink>
          //     </div>
          //   </div>
          // </div>
        )}
      </div>
      {isModel?.email ? <Forgetpassword onClose={handleClose} setLogin={setLoginpass} login={loginpass} /> : <></>}
      {!!isModel?.otp ? <Otp login={loginpass} /> : <></>}
      {!!isModel?.confirmpassword ? <Confirmpassword logindata={loginpass} /> : <></>}
    </div>
  );
}

export default Login;
